<template>
  <div>
    <div class="clearfix"></div>
    <div class="banner" @click="handleCloseMenu">
      <mainMenu ref="mainMenu"></mainMenu>
      <!--BANNER	-->
      <div class="mini-banner">
      	<h1 class="f_spec_sc-R">{{goodsType}}</h1>
      </div>
    </div>

    <!--  Search by type	-->
    <div class="featured-models" @click="handleCloseMenu">
    	<div class="container">
        <h1 class="f_spec_sc-B">Featured Models</h1>
    	</div>

    	<!-- Swiper 2 -->
      <div class="swiper-container  featured-list" ref="featuredSwiper">
        <ul class="swiper-wrapper prd-list">
          <li class="swiper-slide prd-item" v-for="(item,index) in featuredList" :key="index">
            <a  @click="tt(item.goodsId)">
              <div class="prd-img">
                <img :src="item.picUrl" class="img-responsive" alt="">
              </div>
              <b class="prd-brand">{{ item.brandName }}</b>
              <p class="prd-name">{{ item.goodsName }}</p>
              <span class="prd-price">{{ item.originalPrice }}</span>
            </a>
          </li>
        </ul>
        <div class="swiper-scrollbar"></div>
      </div>
    	<p></p><p></p>
    </div>

    <!-- filter -->
    <div class="watches">
      <div class="watches-bar" v-if="filterList.length>0">
        <p class="container">
          <a href="#" class="filter-btn pull-left f_kelly-R">
            Filter <i class="icons filter-icon pull-right"></i>
          </a>
          <a href="#" class="sort pull-right f_kelly-R">
            Sort <span class="glyphicon glyphicon-menu-down" aria-hidden="true"></span>
          </a>
        </p>
      </div>
      <div class="watches-bar" v-if="filterList.length===0">
        <p class="container" style="text-align: center;">
         No related products found temporarily
        </p>
      </div>
    	<div class="container">
    		<ul class="watches-list row">
    				<li class="watches-item" v-for="(item,index) in filterList" id="filter-list" :key="index">
              <span class="icons like" :class="{'active': item.isWish}" aria-hidden="true" title="wish list" @click="wishButton(item.isWish,index,item.goodsId)"></span>
    					<div class="prd-img">
                <a @click="tt(item.goodsId)">
                  <img :src="item.picUrl" class="img-responsive" alt="">
                </a>
              </div>
    					<a href="#">
                <b class="prd-brand">
                  {{ item.brandName }}
                  <i class="icons box" title="with box" v-if="item.originalBox==1"></i>
                  <i class="icons paper" title="with paper" v-if="item.originalPapers==1"></i>
                </b>
                <p class="prd-name">{{ item.goodsName }}</p>
                <p class="prd-info">{{ item.goodsId }}</p>
              </a>
              <p class="prd-price" v-if="item.webPrice" style="font-size: 19px;">
                <span class="new-price">HK{{ item.webPrice }}.00</span>
                <span class="old-price">HK{{ item.originalPrice }}.00</span>
              </p>
               <p class="prd-price" v-else style="font-size: 19px;">
                <span class="new-price" style="color: #111">HK{{ item.originalPrice }}.00</span>
               </p>
    				</li>

            <li class="clearfix"></li>
            <!-- <nav aria-label="Page navigation" class="text-center" style="width: 100%;">
              <ul class="pagination">
                <li class="disabled">
                  <a aria-label="Previous">
                    <span aria-hidden="true">&laquo;</span>
                  </a>
                </li>
                <li class="active"><a>1</a></li>
                <li><a href="#">2</a></li>
                <li><a>...</a></li>

                <li><a href="#">6</a></li>
                <li>
                  <a href="#" aria-label="Next">
                    <span aria-hidden="true">&raquo;</span>
                  </a>
                </li>
              </ul>
            </nav> -->
          <!-- <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="filterQuery.page"
            :page-sizes="[10, 15, 20, 25]"
            :page-size="10"
            layout="total, prev, pager, next"
            :total=filterTotal style="width: 100%;text-align:center;padding-top:10px">
          </el-pagination> -->

           <nav aria-label="Page navigation" class="d-flex w-100 justify-content-between">
              <!-- <b-pagination
                v-model="filterCurrentPage"
                pills
                :total-rows="filterTotal"
                :per-page="filterQuery.limit"
                aria-controls="filter-list"
                @change="handleFilterPageChange"
                first-number
                :limit="4"
              >
                <template #prev-text>
                  <span v-show="filterCurrentPage > 1">
                    <img :src="require('@/assets/xh/images/prev_page.png')"/>
                  </span>
                </template>
                <template #next-text>
                  <span v-show="filterCurrentPage < pageCount" style="border:none">
                    <img :src="require('@/assets/xh/images/next_page.png')"/>
                  </span>
                </template>
                <template #last-text>
                  <span v-show="filterCurrentPage < pageCount">
                    <img :src="require('@/assets/xh/images/last_page.png')"/>
                  </span>
                </template>
              </b-pagination> -->

              <div class="d-flex page-limit">
                <span :class="[{active: item === filterQuery.limit}]" v-for="item in pageNum" @click="handlePageNum(item)">{{ item }}</span>
              </div>

              <base-pagination
                v-model="filterCurrentPage"
                :pageCount="pageCount"
                :perPage="filterQuery.limit"
                :total="filterTotal"
                @input="handleCurrentChange"
              ></base-pagination>
              <div></div>
            </nav>
            <div class="d-flex justify-content-center w-100 pagination-total" v-show="filterTotal > 0">
              Total {{ filterTotal }} items
            </div>
    		</ul>
    	</div>
    </div>

  </div>
</template>

<script>
import MainMenu from "@/components/MainMenu";
import BasePagination from "@/components/BasePagination";
import Swiper, { Navigation, Pagination } from 'swiper'
import {selectListByType,selectList,selectListByName,selectListByNameAndUserId,addOrUpdateWish} from '@/api/watchList'
import Vue from 'vue'
export default {
  name: 'WatchList',
  components: {
    MainMenu,
    BasePagination
  },
  data() {
    return {
      goodsType:undefined,
      featuredList: [],
      filterList: [],
      filterCurrentPage: 1,
      filterTotal: 0,
      filterQuery: {
        goodsName: undefined,
        page: 1,
        limit: 30,
      },
      pageNum: [30, 60, 90],
    };
  },
  created() {
   var type = this.$route.query.goodsType
   if(type===undefined){
     this.goodsType = 'BEST SALE'
      type='bestSale'
   }else if(type==='bestSale'){
      this.goodsType = 'BEST SALE'
   }else{
     this.goodsType = 'NEW ARRIVAL'
   }
   selectListByType({goodsType:type,isShow: 1}).then(response=>{
     this.featuredList=response.data.data.list
     console.log(this.featuredList)
   })
   this.init()
   return;

/*    this.featuredList = [
      {id:1, src:require('@/assets/xh/images/homeprd3.png'), brand:'Omega', name:'Constellation', price:'$ 180,000'},
      {id:2, src:require('@/assets/xh/images/homeprd2.png'), brand:'Omega', name:'Constellation', price:'$ 180,000'},
      {id:3, src:require('@/assets/xh/images/homeprd1.png'), brand:'Omega', name:'Constellation', price:'$ 180,000'},
      {id:4, src:require('@/assets/xh/images/homeprd2.png'), brand:'Omega', name:'Constellation', price:'$ 180,000'},
      {id:5, src:require('@/assets/xh/images/homeprd1.png'), brand:'Omega', name:'Constellation', price:'$ 180,000'},
      {id:6, src:require('@/assets/xh/images/homeprd3.png'), brand:'Omega', name:'Constellation', price:'$ 180,000'},
      {id:7, src:require('@/assets/xh/images/homeprd2.png'), brand:'Omega', name:'Constellation', price:'$ 180,000'},
      {id:8, src:require('@/assets/xh/images/homeprd1.png'), brand:'Omega', name:'Constellation', price:'$ 180,000'},
      {id:9, src:require('@/assets/xh/images/homeprd2.png'), brand:'Omega', name:'Constellation', price:'$ 180,000'},
      {id:10, src:require('@/assets/xh/images/homeprd1.png'), brand:'Omega', name:'Constellation', price:'$ 180,000'},
    ]*/

    this.filterList = [
      {id:1, picUrl:require('@/assets/xh/images/homeprd3.png'), brand:'Omega', name:'Constellation', price:'$ 170,000',
       attrs: 'SSF007, Heritage Automatic 42 mm', isWish:true, isPaper:true, isBox:true, originalPrice:'$ 180,000'},
      {id:2, picUrl:require('@/assets/xh/images/homeprd2.png'), brand:'Omega', name:'Constellation', price:'$ 180,000',
       attrs: 'SSF007, Heritage Automatic 42 mm', isWish:false, isPaper:true, isBox:true, originalPrice:''},
      {id:3, picUrl:require('@/assets/xh/images/homeprd1.png'), brand:'Omega', name:'Constellation', price:'$ 180,000',
       attrs: 'SSF007, Heritage Automatic 42 mm', isWish:true, isPaper:false, isBox:true, originalPrice:''},
      {id:4, picUrl:require('@/assets/xh/images/homeprd2.png'), brand:'Omega', name:'Constellation', price:'$ 180,000',
       attrs: 'SSF007, Heritage Automatic 42 mm', isWish:false, isPaper:true, isBox:true, originalPrice:''},
      {id:5, picUrl:require('@/assets/xh/images/homeprd1.png'), brand:'Omega', name:'Constellation', price:'$ 180,000',
       attrs: 'SSF007, Heritage Automatic 42 mm', isWish:false, isPaper:false, isBox:false, originalPrice:''},
      {id:6, picUrl:require('@/assets/xh/images/homeprd3.png'), brand:'Omega', name:'Constellation', price:'$ 180,000',
       attrs: 'SSF007, Heritage Automatic 42 mm', isWish:true, isPaper:false, isBox:false, originalPrice:''},
      {id:7, picUrl:require('@/assets/xh/images/homeprd2.png'), brand:'Omega', name:'Constellation', price:'$ 180,000',
       attrs: 'SSF007, Heritage Automatic 42 mm', isWish:false, isPaper:true, isBox:true, originalPrice:''},
      {id:8, picUrl:require('@/assets/xh/images/homeprd1.png'), brand:'Omega', name:'Constellation', price:'$ 180,000',
       attrs: 'SSF007, Heritage Automatic 42 mm', isWish:false, isPaper:true, isBox:true, originalPrice:''},
      {id:9, picUrl:require('@/assets/xh/images/homeprd2.png'), brand:'Omega', name:'Constellation', price:'$ 180,000',
       attrs: 'SSF007, Heritage Automatic 42 mm', isWish:false, isPaper:true, isBox:true, originalPrice:''},
      {id:10, picUrl:require('@/assets/xh/images/homeprd1.png'), brand:'Omega', name:'Constellation', price:'$ 180,000',
       attrs: 'SSF007, Heritage Automatic 42 mm', isWish:false, isPaper:true, isBox:true, originalPrice:''},
    ]
  },
  computed: {
    pageCount() {
      let l = this.filterTotal / this.filterQuery.limit
      console.log(Math.ceil(l))
      return Math.ceil(l);
    }
  },
  mounted() {
    new Swiper(this.$refs.featuredSwiper, {
      // configure Swiper to use modules
      modules: [Navigation, Pagination],
      // Optional parameters
      // loop: true,
      slidesPerView: 'auto',
      spaceBetween: 30,
      observer: true,
      observeParents: true,
      freeMode: true,
      // direction: "horizontal",
      // followFinger: true,
      mousewheel: true,
      // If we need pagination
      // pagination: {
      //   el: '.swiper-pagination',
      // },

      // Navigation arrows
      // navigation: {
      //   nextEl: '.benefits-next',
      //   prevEl: '.benefits-prev',
      // },

      // And if we need scrollbar
      scrollbar: {
        el: '.swiper-scrollbar',
      },
    })
    console.log(this.$route.query.name)
    this.$refs.mainMenu.searchContent = this.$route.query.name
    this.$refs.mainMenu.searchFocus= false
    this.$refs.mainMenu.isHovered = false
  },
  methods: {

    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.filterQuery.limit = val;
      this.init();
    },
    handleCurrentChange(val) {
      this.filterQuery.page = val;
      this.filterCurrentPage = val;
      console.log(`当前页: ${val}`);
      this.init();
    },
    init(){
      var name = this.$route.query.name
      if(name===undefined){
        //代表未搜索
        if(this.$store.getters.userId){
          console.log('已登录')
          //代表已登录
          this.filterQuery.userId=this.$store.getters.userId
          console.log(this.filterQuery)
          this.getListByNameAndUserId()
        }else{
           this.getList();
        }
      }else{
        //代表搜索进来的
        console.log('==='+name)
        this.filterQuery.goodsName=name
        if(this.$store.getters.userId){
          console.log('已登录')
          //代表已登录
          this.filterQuery.userId=this.$store.getters.userId
          console.log(this.filterQuery)
          this.getListByNameAndUserId()
        }else{
           this.getListByName()
        }
      }
    },

    getList(){
      console.log('进来了')
      selectList(this.filterQuery).then(response=>{
        this.filterList=response.data.data.list
        this.filterTotal = response.data.data.total
        console.log(this.filterList)
      })
    },
   getListByName(){
      selectListByName(this.filterQuery).then(response=>{
        this.filterList=response.data.data.list
        this.filterTotal = response.data.data.total
        console.log(this.filterList)
      })
    },
    getListByNameAndUserId(){
       selectListByNameAndUserId(this.filterQuery).then(response=>{
         this.filterList=response.data.data.list
         this.filterTotal = response.data.data.total
         console.log(this.filterList)
       })
     },
    getFilterList(page) {
      if (page % 3 == 0) {
        this.filterList = [
          {id:1, picUrl:require('@/assets/xh/images/homeprd1.png'), brand:'Omega', name:'Constellation', price:'$ 170,000',
           attrs: 'SSF007, Heritage Automatic 42 mm', isWish:true, isPaper:true, isBox:true, originalPrice:'$ 180,000'},
          {id:2, picUrl:require('@/assets/xh/images/homeprd1.png'), brand:'Omega', name:'Constellation', price:'$ 180,000',
           attrs: 'SSF007, Heritage Automatic 42 mm', isWish:false, isPaper:true, isBox:true, originalPrice:''},
          {id:3, picUrl:require('@/assets/xh/images/homeprd1.png'), brand:'Omega', name:'Constellation', price:'$ 180,000',
           attrs: 'SSF007, Heritage Automatic 42 mm', isWish:true, isPaper:false, isBox:true, originalPrice:''},
          {id:4, picUrl:require('@/assets/xh/images/homeprd1.png'), brand:'Omega', name:'Constellation', price:'$ 180,000',
           attrs: 'SSF007, Heritage Automatic 42 mm', isWish:false, isPaper:true, isBox:true, originalPrice:''},
          {id:5, picUrl:require('@/assets/xh/images/homeprd1.png'), brand:'Omega', name:'Constellation', price:'$ 180,000',
           attrs: 'SSF007, Heritage Automatic 42 mm', isWish:false, isPaper:false, isBox:false, originalPrice:''},
        ]
      } else if (page % 3 == 1) {
        this.filterList = [
          {id:1, picUrl:require('@/assets/xh/images/homeprd2.png'), brand:'Omega', name:'Constellation', price:'$ 170,000',
           attrs: 'SSF007, Heritage Automatic 42 mm', isWish:true, isPaper:true, isBox:true, originalPrice:'$ 180,000'},
          {id:2, picUrl:require('@/assets/xh/images/homeprd2.png'), brand:'Omega', name:'Constellation', price:'$ 180,000',
           attrs: 'SSF007, Heritage Automatic 42 mm', isWish:false, isPaper:true, isBox:true, originalPrice:''},
          {id:3, picUrl:require('@/assets/xh/images/homeprd2.png'), brand:'Omega', name:'Constellation', price:'$ 180,000',
           attrs: 'SSF007, Heritage Automatic 42 mm', isWish:true, isPaper:false, isBox:true, originalPrice:''},
          {id:4, picUrl:require('@/assets/xh/images/homeprd2.png'), brand:'Omega', name:'Constellation', price:'$ 180,000',
           attrs: 'SSF007, Heritage Automatic 42 mm', isWish:false, isPaper:true, isBox:true, originalPrice:''},
          {id:5, picUrl:require('@/assets/xh/images/homeprd2.png'), brand:'Omega', name:'Constellation', price:'$ 180,000',
           attrs: 'SSF007, Heritage Automatic 42 mm', isWish:false, isPaper:false, isBox:false, originalPrice:''},
        ]
      } else if (page % 3 == 2) {
        this.filterList = [
          {id:1, picUrl:require('@/assets/xh/images/homeprd3.png'), brand:'Omega', name:'Constellation', price:'$ 170,000',
           attrs: 'SSF007, Heritage Automatic 42 mm', isWish:true, isPaper:true, isBox:true, originalPrice:'$ 180,000'},
          {id:2, picUrl:require('@/assets/xh/images/homeprd3.png'), brand:'Omega', name:'Constellation', price:'$ 180,000',
           attrs: 'SSF007, Heritage Automatic 42 mm', isWish:false, isPaper:true, isBox:true, originalPrice:''},
          {id:3, picUrl:require('@/assets/xh/images/homeprd3.png'), brand:'Omega', name:'Constellation', price:'$ 180,000',
           attrs: 'SSF007, Heritage Automatic 42 mm', isWish:true, isPaper:false, isBox:true, originalPrice:''},
          {id:4, picUrl:require('@/assets/xh/images/homeprd3.png'), brand:'Omega', name:'Constellation', price:'$ 180,000',
           attrs: 'SSF007, Heritage Automatic 42 mm', isWish:false, isPaper:true, isBox:true, originalPrice:''},
          {id:5, picUrl:require('@/assets/xh/images/homeprd3.png'), brand:'Omega', name:'Constellation', price:'$ 180,000',
           attrs: 'SSF007, Heritage Automatic 42 mm', isWish:false, isPaper:false, isBox:false, originalPrice:''},
        ]
      }

    },
    handleCloseMenu(event) {
      var sp = document.getElementById("headMenu")
      if (!sp.contains(event.target)) {
      	this.$refs.mainMenu.searchFocus = false;
      	this.$refs.mainMenu.isHovered = false;
      }
    },
    handleFilterPageChange(page) {
      this.filterCurrentPage = page;
      console.log(this.filterCurrentPage, page, this.pageCount)
      this.getFilterList(page);
    },
    tt(id){
     this.$router.push({ path: 'watchpage', query: { id: id }}, () => {})
    },
    wishButton(isWish,index,goodsId){
      if(!this.$store.getters.userId){
        this.$router.push('/login')
      }else{
        if(isWish===undefined){
          this.filterList[index].isWish=true
        }else{
          this.filterList[index].isWish=!isWish
        }
        addOrUpdateWish({userId:this.$store.getters.userId,goodsId:goodsId,addOrUpdateSwitch:!isWish}).then(res=>{
          console.log(res.data)
        })
        Vue.set(this.filterList,index,this.filterList[index])
      }
    },
    handlePageNum(num) {
      this.filterQuery.limit = num;
    }
  }
}
</script>

<style scoped>
@import url("../assets/xh/css/bootstrap.min.css");
@import url("../assets/xh/css/reset.css");
@import url("../assets/xh/css/watches.css");
.pagination {
  display: flex;
}
/* >>>不可去除，否则样式无法深度替换 */
>>> .pagination button {
  font-family: 'Spectral';
  font-size: 18px;
  width: 49px;
  height: 49px;
}
>>> .pagination span {
  font-family: 'Spectral';
  font-size: 18px;
  width: 49px;
  height: 49px;
  color: black;
}
.pagination {
  margin-bottom: 0.5rem;
}
.pagination-total {
  font-size: 18px;
  margin-bottom: 3rem;
  margin-left: 105px;
}
.page-limit {
  padding-top: 1.5rem;
  padding-left: 30px;
}
.page-limit span {
  display: inline-block;
  width: 35px;
  height: 28px;
  font-family: 'Spectral';
  font-size: 18px;
  line-height: 27px;
  text-align: center;
  cursor: pointer;
}
.page-limit span.active {
  background: #ebebeb;
  border-radius: 7px;
}
</style>



// WEBPACK FOOTER //
// src/views/WatchListView.vue